import { SJSpinner } from '@/components/ui';

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <SJSpinner size="lg" />
        <p className="text-sm text-[var(--sj-text-muted)]">Loading...</p>
      </div>
    </div>
  );
}
